/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Settings_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configure how the compliance copilot escalates sensitive interactions." |
*
* @param {Compliance_Copilot_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_settings_description = /** @type {((inputs?: Compliance_Copilot_Settings_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Settings_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren Sie, wie der Compliance-Copilot sensible Interaktionen eskaliert.")
	return /** @type {LocalizedString} */ ("Configure how the compliance copilot escalates sensitive interactions.")
});